import React, { useState } from 'react';
import Agent from "../../Network/Agent";
import ToolBar from "../../Components/Elements/ToolBar";
import InputPrimary from "../../Components/Elements/InputPrimary";
import ButtonPrimary from "../../Components/Elements/ButtonPrimary";
import {projectUrl} from "../../Config/SharedConfig";
import {getRedirectUrl} from "../../Components/Utils/getRedirectUrl";

const Create = () => {
    const [buttonLoading, setButtonLoading] = useState(false);
    const [username, setUsername] = useState('');
    const [usernameError, setUsernameError] = useState(null);

    const submitStore = async (e) => {
        e.preventDefault();
        setButtonLoading(true);
        setUsernameError(null);

        try {
            const response = await Agent.Store.create(username);
            const {store} = response.data.result

            const token = Agent.getAuthToken()
            window.location.href = getRedirectUrl(store.username, token)
        } catch (error) {
            console.log(error.response);
            setUsernameError(error.response?.data.errors.at(0).message || 'خطا در ثبت نام کاربر');
            setButtonLoading(false);
        }
    };

    return (
        <>
            <ToolBar title={'ایجاد فروشگاه'} url={""} arrowDisplay={"d-none"} />
            <section>
                <div className='container'>
                    <div className='row'>
                        <div className='col-12'>
                            <div className='mobile-subtitle-regular cl-subtitle mt-8'>
                                برای ساخت فروشگاه لطفا یک نام کاربری وارد کنید:
                            </div>
                        </div>
                        <div className='col-12'>
                            <form id='form_send_store' onSubmit={submitStore}>
                                <div className='mt-32'>
                                    <InputPrimary
                                        inputClasses={!usernameError ? 'dir-ltr' : 'dir-ltr hasError'}
                                        name='username'
                                        id='username'
                                        type='text'
                                        value={username}
                                        onChange={(e) => setUsername(e.target.value)}
                                        placeHolder='digilog : مثال'
                                    />
                                    {usernameError && (
                                        <div className='mobile-body-1-regular cl-tomato mt-custom-4 mr-8'>
                                            {usernameError}
                                        </div>
                                    )}
                                </div>
                                <div className='mt-32'>
                                    <ButtonPrimary
                                        mode='dark-mode'
                                        text='ایجاد برند'
                                        isLoading={buttonLoading}
                                    />
                                </div>
                            </form>
                            <div className="mt-20">
                                <ul className="mobile-body-1-regular cl-subtitle pr-16 pl-0">
                                    <li>
                                        نام کاربری باید ۵ تا ۲۰ کاراکتر باشد.
                                    </li>
                                    <li>
                                        با یک حرف شروع شود.
                                    </li>
                                    <li>
                                        فقط یک زیرخط (_) مجاز است و نباید در ابتدا یا انتها باشد.
                                    </li>
                                    <li>
                                        از حروف و اعداد استفاده کنید.
                                    </li>
                                    <li>
                                        نام کاربری از قسمت تنظیمات قابل تغییر میباشد.
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Create;
